import React from "react";

function HomeSplash() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 392.2 600">
      <defs>
        <linearGradient
          id="Dégradé_sans_nom"
          x1="-265.8"
          x2="-265.8"
          y1="442.26"
          y2="441.36"
          gradientTransform="matrix(380 0 0 -600 101193 265352.75)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#031e3f"></stop>
          <stop offset="1" stopColor="#030f1f"></stop>
        </linearGradient>
        <clipPath id="clip-path">
          <path fill="none" d="M4 0h376v600H4a4 4 0 01-4-4V4a4 4 0 014-4z"></path>
        </clipPath>
        <clipPath id="clip-path-2">
          <path fill="none" d="M47.37 229.53H220.98000000000002V406.47H47.37z"></path>
        </clipPath>
        <clipPath id="clip-path-3">
          <path fill="none" d="M300.45 284.51H392.21V365.2H300.45z"></path>
        </clipPath>
      </defs>
      <path fill="url(#Dégradé_sans_nom)" d="M4 0h376v290.71S0 539.49 0 537.28V4a4 4 0 014-4z"></path>
      <g clipPath="url(#clip-path)">
        <g>
          <g>
            <path fill="#fff" d="M0 537.28l380-246.57V600H0z"></path>
            <path fill="#ffd420" d="M0 542.39l380-171.23V600H0z" data-name="Rectangle Copy 2"></path>
          </g>
          <g data-name="Item perso astro-karate Copy 5">
            <path
              fill="#052e61"
              d="M304 373c-4.05-1.25-14.84-3.61-18-.35-15.63 16.28-28.73 47-54.5 60.87l-21.25 31-36.42 8.77s-41.13 52.18-14 61.4c13 4.43 38.38 5.78 53.08.36 3.68-1.3 4-8.64 4.72-11.6a346.44 346.44 0 0037.24-17.05l-19.71-33s-39.37 24.84-40.38 22.72c-3-5.95 23.25-20.59 23.25-20.59 85.72-38.8 140.85-84.4 162-103.6v-13.32l-46.94-19.93S320.3 354.47 304 373z"
            ></path>
            <path
              fill="#009cdb"
              d="M333.06 338.68s-12.68 15.65-28.84 34.08c7 16.56 19.34 27 33.58 33.56Q359.72 390 380 371.67v-13.06z"
            ></path>
            <path
              fill="#0086bc"
              d="M44.25 322.45l6.38-5.59C42.06 290.69 12.89 276.19 0 270.93v26.35c15.42 3.1 34.65 9.96 44.25 25.17z"
            ></path>
            <path
              fill="#0086bc"
              d="M49.27 326.77l-.27-8.22c-16.07-7.09-33.26-7.66-49-5.33v24.64c14.56-8.51 31.86-14.52 49.27-11.09z"
            ></path>
            <path
              fill="#c6c3c2"
              d="M270.09 317.82a7.87 7.87 0 00-8.74-1.15C253 327 238 345.24 221.26 365.61l12.23 9.28 39.58-49s1.55-4.49-3-8.11"
              data-name="Fill 1"
            ></path>
            <path
              fill="#a4a2a1"
              d="M230.17 354.76c-2.9 3.52-5.88 7.15-8.91 10.85l12.23 9.28 7.91-9.78a58.07 58.07 0 00-11.23-10.35"
              data-name="Fill 3"
            ></path>
            <path
              fill="#a4a2a1"
              d="M245.94 335.52l-5.29 6.48a56.45 56.45 0 0111.79 9.49l4.12-5.1a45.55 45.55 0 00-10.62-10.84"
              data-name="Fill 5"
            ></path>
            <path
              fill="#a4a2a1"
              d="M250.57 329.86a41.67 41.67 0 018.89 12.91l4.41-5.45a68.42 68.42 0 00-11.7-9.42l-1.6 2"
              data-name="Fill 7"
            ></path>
            <path
              fill="#a4a2a1"
              d="M270.09 317.82a7.87 7.87 0 00-8.74-1.15l-4.72 5.78a67.87 67.87 0 019.92 11.55l6.52-8.07s1.55-4.49-3-8.11"
              data-name="Fill 9"
            ></path>
            <path
              fill="#e8e3e2"
              d="M238.36 344.77l-4.65 5.66c4.48 2.46 8.75 5.48 13 8.06l2.22-2.75a58 58 0 00-10.62-11"
              data-name="Fill 11"
            ></path>
            <path
              fill="#d38252"
              d="M232.3 362.31c-11-8.23-17.27-8.42-19.91-4.92s-.73 9.4 10.32 17.63 17.27 8.43 19.92 4.92.72-9.4-10.33-17.63"
              data-name="Fill 13"
            ></path>
            <path
              fill="#724324"
              d="M103.25 512.85a9 9 0 003.33 9.25c4.94 4.13 10.53.76 10.53.76L232.83 375l-11.72-9.25c-17.69 21.68-87.18 109.76-117.86 147.14"
              data-name="Fill 15"
            ></path>
            <path
              fill="#d38252"
              d="M271.63 314.73a9.46 9.46 0 00-10.55-.83c-1.4 1.92-3.07 4.45-4.79 6.8l5 3.73c.56-.78 1.11-1.6 1.57-2.23a3.13 3.13 0 013.51.27 3 3 0 011.35 3.17L266 328l4.55 3.4 5.17-7.13s1.58-5.47-4.08-9.52"
              data-name="Fill 17"
            ></path>
            <path
              fill="#052e61"
              d="M146.13 398.34s-10.76 52.77-15.07 53.89-25.51-16.6-25.51-16.6l-13 38s45.5 22.15 60.45 4.37 4-68.42 4-68.42z"
              data-name="Fill 19"
            ></path>
            <path
              fill="#009cdb"
              d="M105.55 435.63l-13 38a144.63 144.63 0 0019.2 7.34c8-9.13 12.17-20.16 11.6-32a210.59 210.59 0 01-17.84-13.34"
              data-name="Fill 21"
            ></path>
            <path
              fill="#052e61"
              d="M195.71 381.39l-49.42 16.22s5.23 47.15 27.55 75.7c4.12 5.28 15.55 8.66 41.54-1s31.11-39.54 28.93-44.49c-33.78-12.68-48.6-46.4-48.6-46.4"
              data-name="Fill 23"
            ></path>
            <path fill="#052e61" d="M166.27 421.27l7.53-24.57-20.39 7.23z" data-name="Fill 25"></path>
            <path fill="#009cdb" d="M148.7 404l16.81 23 1.31-6.9-12.21-16.3z" data-name="Fill 27"></path>
            <path
              fill="#009cdb"
              d="M158.66 445.91c1.38 3.46 2.92 6.92 4.6 10.3L181.6 386l-6.6 2.2z"
              data-name="Fill 29"
            ></path>
            <path
              fill="#009cdb"
              d="M205 491.63l13.07 31.67a345.39 345.39 0 0036.81-16.88l-19.71-33S217 485 205 491.63"
              data-name="Fill 34"
            ></path>
            <path
              fill="#031e3f"
              d="M217.51 521.92l-.77-1.86 1-2.65-2.47-1-.72-1.75 3.66 1.46 3.45-9.39-12.46-4.93-1.33-3.24 3.81-10.38-.39-.16 2.42-1.42-.3.81 13.36 5.32 4.23-11.42-5.12-2 .8-.5.61-.38 4.16 1.66 2-5.49 1.74-1.09.07.12-2.56 7 8.82 3.51 1.15 1.91-10.43-4.15-4.24 11.33 13.12 5.23 3.41-9.3.9 1.5-3 8.3 7.54 3-.51 1.26-7.5-3-4.21 11.47 3.71 1.48-1.35.64-.3.14-2.5-1-1 2.6-1.74.79 1.43-3.89-13.12-5.22-3.45 9.39 7.6 3-1.78.75-6.28-2.5-1.47 4zm10.06-27.42l-4.21 11.5 13.12 5.22 4.21-11.47zm-14.63-5.82l-4.2 11.47 13.35 5.32 4.22-11.47z"
              data-name="Fill 36"
            ></path>
            <path
              fill="#f4d6a6"
              d="M98.27 425a15.54 15.54 0 00-14.22-2.48c-12.36 4.1-15.46 29.4-14.25 35.57 2.1 10.67 16.14 17.21 23.2 15.41s14.62-27.18 13.51-36.55a.58.58 0 00-.05-.29c2.32-7.15-.19-16.69-8.22-11.66"
              data-name="Fill 38"
            ></path>
            <path
              fill="#052e61"
              d="M232.82 474.8s11.22 38.67 19.72 43 23.46-1.09 23.46-1.09l-38.57-47.51s-3.88 2.43-4.61 5.6"
              data-name="Fill 40"
            ></path>
            <path
              fill="#e0bf89"
              d="M100.64 427.09a1.7 1.7 0 00-.06.31 63.23 63.23 0 01-.55 8.7c-5.76-7-16-7.84-16.42-7.88a1.35 1.35 0 00-1.43 1.23 1.32 1.32 0 001.2 1.43c.12 0 11.43 1 15.9 8.84l.14.18c-.44 2.44-1 4.84-1.63 7.13-5.77-7.44-17-9.22-17.54-9.29a1.34 1.34 0 10-.63 2.61h.23c.12 0 12.39 1.95 16.89 9.87v.06a55.37 55.37 0 01-2.74 6.79c-5.45-6.79-16.41-8.92-16.9-9a1.36 1.36 0 00-1.58 1.06 1.34 1.34 0 001.07 1.56c.12 0 11.52 2.24 16 9-1.62 2.61-3.33 4.3-5 4.6-6.25 1.16-11.91-4.64-12-4.7a1.35 1.35 0 00-1.9 0 1.34 1.34 0 00-.06 1.88c.24.26 5.51 5.7 12.21 5.7A10.79 10.79 0 0088 467c7.73-1.43 14.45-20.93 15-36.7a18.92 18.92 0 00-1.39-1.58 14.47 14.47 0 00-1.19-1.52"
              data-name="Fill 42"
            ></path>
            <path
              fill="#e0bf89"
              d="M333.26 473.16l-21.46 1.3s4.65 11.34 10 12.1 23-3.47 27.07-10.38c3.49-5.89-5.34-9.94-15.64-3"
              data-name="Fill 44"
            ></path>
            <g data-name="Group 52">
              <path fill="none" d="M47.37 229.53H221v176.94H47.37z" data-name="Clip 51-2"></path>
              <g clipPath="url(#clip-path-2)">
                <g data-name="Group 52-2">
                  <path
                    fill="#052e61"
                    d="M127.44 229.84C79.73 233.23 42.92 262 47.81 330.13c4.75 66.2 44.56 79.23 92.26 75.85s85.27-21.92 80.51-88.12c-4.88-68.11-45.43-91.4-93.14-88"
                    data-name="Fill 50"
                  ></path>
                </g>
              </g>
            </g>
            <path
              fill="#031e3f"
              d="M105.9 241.41c64.9-7.27 97.64 30.39 97.64 30.39s-26.4-50.45-97.64-30.39"
              data-name="Fill 53"
            ></path>
            <path
              fill="#f4d6a6"
              d="M59.24 344.7c.89 12.36-.6 22.53 76.8 17 74.17-5.26 74.49-15.35 73.61-27.71S207 311.7 132.84 317c-77.42 5.49-74.48 15.35-73.6 27.7z"
              data-name="Fill 55"
            ></path>
            <path
              fill="#e0bf89"
              d="M59 339l149.88-10.64c-2.52-9.46-13.73-15.77-76-11.34C67.8 321.62 59.47 329.31 59 339z"
              data-name="Fill 57"
            ></path>
            <path fill="#fefefe" d="M170.4 325.49a14.06 14.06 0 10.08 0h-.08" data-name="Fill 59"></path>
            <path
              fill="#1d1d1b"
              d="M179.8 328a13.14 13.14 0 10-3 25.62 7.49 7.49 0 001.06-.13 14.69 14.69 0 002-25.49"
              data-name="Fill 61"
            ></path>
            <path fill="#fefefe" d="M87.83 330.39a14.23 14.23 0 10.09 0h-.09" data-name="Fill 63"></path>
            <path
              fill="#1d1d1b"
              d="M97.22 332.93a13.14 13.14 0 10-3 25.61 6.27 6.27 0 001.06-.13 14.69 14.69 0 002-25.48"
              data-name="Fill 65"
            ></path>
            <path
              fill="#1b1c1c"
              d="M154.68 333.79l-4.88-2.41c10-20 36.93-17 38.07-16.84l-.65 5.37c-.24 0-24.27-2.65-32.54 13.87"
              data-name="Fill 67"
            ></path>
            <path
              fill="#1b1c1c"
              d="M107.94 337.25c-10.58-15.24-34-9.18-34.26-9.12l-1.42-5.23c1.12-.3 27.43-7.07 40.17 11.28z"
              data-name="Fill 69"
            ></path>
            <path
              fill="#009cdb"
              d="M132.29 297.32C77.24 301.23 43.82 315 43.82 315L46 340.47s32.63-12 88.2-15.94 89.36 3.32 89.36 3.32l-1.46-25.55s-34.82-8.89-89.85-5"
              data-name="Fill 71"
            ></path>
            <path
              fill="#031e3f"
              d="M108.88 376.88c39 13 62.53-5.26 62.53-5.26s-29.1 10.07-62.53 5.26"
              data-name="Fill 73"
            ></path>
            <path fill="#031e3f" d="M158 384.89s-22.35 9.51-36 9.52c21 3.36 36-9.52 36-9.52" data-name="Fill 75"></path>
            <path
              fill="#052e61"
              d="M201.21 399.2c18 5.38 112.12 65.51 112.12 65.51l14.37-42.94S208.82 379.88 198 381.34s-14.75 12.49 3.21 17.86z"
              data-name="Fill 77"
            ></path>
            <path
              fill="#009cdb"
              d="M280.42 444.06c18.56 11.49 32.91 20.65 32.91 20.65l14.38-42.94s-12.27-4.32-29.28-10.14c-14.22 3.84-19.92 16.85-18 32.43"
              data-name="Fill 79"
            ></path>
            <path
              fill="#f4d6a6"
              d="M323.2 420.58c-7.71.67-19.49 29.33-21.17 40.36s21.87 28 32.87 20.88 14.25-24.35 15.09-36.24-19.07-25.67-26.79-25"
              data-name="Fill 81"
            ></path>
            <path
              fill="#e0bf89"
              d="M308.14 463.62a1.33 1.33 0 00.33 1.85 116.35 116.35 0 0029.36 14 24.15 24.15 0 002.09-2.2 114.83 114.83 0 01-29.9-14 1.36 1.36 0 00-1.89.33"
              data-name="Fill 83"
            ></path>
            <path
              fill="#e0bf89"
              d="M313.9 450.48a1.35 1.35 0 00.42 1.85c.16.1 15.17 9.12 31.82 13.42.3-.85.57-1.71.83-2.58-16.29-4.17-31.07-13.05-31.22-13.17a1.37 1.37 0 00-1.86.45"
              data-name="Fill 85"
            ></path>
            <path
              fill="#e0bf89"
              d="M319.78 437.65a1.35 1.35 0 00.57 1.81 144.51 144.51 0 0029.21 10.59c.11-.92.2-1.82.28-2.7a142.43 142.43 0 01-28.24-10.28 1.37 1.37 0 00-1.83.58"
              data-name="Fill 87"
            ></path>
            <path
              fill="#009cdb"
              d="M171.81 470.6c.55.77 1.12 1.51 1.69 2.25 4.53-6.41 27.34-36.21 66.57-46.82-1.24-.56-2.46-1.14-3.65-1.75-37 11.1-59 38.6-64.61 46.32"
              data-name="Fill 98"
            ></path>
            <path fill="#031e3f" d="M332.96 403.89L332.96 403.89 332.96 403.89 332.96 403.89z"></path>
            <path
              fill="#031e3f"
              d="M375.49 356.7l-1.33-.57-.72 11.25-18.1.59.74-18.19 2.91-.08-4.2-1.79v.56l-20.09.6.3-9.57-1.34-.57-.32 10.18-9.1.27-.66.79-.5.6 10.21-.31-.57 18.24-17.53.57.18-9.38-1.4 1.63-.14 7.8-6.78.21-1.21 1.4 8-.26-.38 17.33c.58.7 1.17 1.38 1.75 2l16.85-.74-.44 13.81.14.07 1.2.68.46-14.62 19.72-.87-.26 6.26.28-.23 1.13-.9.21-5.18 6.5-.28 1.44-1.19.28-.24-8.17.36.72-17.66 18.08-.59-.6 9.36 1.45-1.26.52-8.15 5.27-.17v-1.36l-5.18.17zM332.1 388l-17.29.76.34-18.1 17.51-.57zm21.09-.93l-19.72.87L334 370l19.89-.65zm.78-19l-19.9.64.57-18.24 20.08-.6z"
            ></path>
            <g data-name="Group 95">
              <path fill="none" d="M300.45 284.51h91.75v80.69h-91.75z" data-name="Clip 94-2"></path>
              <g clipPath="url(#clip-path-3)">
                <g data-name="Group 95-2">
                  <path
                    fill="#052e61"
                    d="M307.93 327.61c7.84 14.13 58.23 33.1 72.07 36.89 0-4 .09-14.57.09-14.57l-75.23-65.42s-11.74 16.41 3.07 43.1"
                    data-name="Fill 93"
                  ></path>
                </g>
              </g>
            </g>
            <path
              fill="#0d3f7d"
              d="M362.89 321.1c-37.74-41.73-58-36.59-58-36.59s-.74 13.46 12.63 32.83c9.6 13.89 43.91 30.06 62.51 38.08v-14.25c-4.19-5.37-9.74-12-17.14-20.07z"
            ></path>
          </g>
        </g>
      </g>
      <g data-name="Group 2">
        <g data-name="ninja s Games">
          <g style={{ isolation: "isolate" }} fill="#fff">
            <path d="M77.6 123.88l-1.36 25.58-9.88.9-5.29-13.69-.83 14h-8.49l.68-26.75 9.44-.46L68.39 137l.3-12.83zM89.31 124.37l-2.07 25.69-8 .42v-25.59z"></path>
          </g>
          <path
            fill="#fff"
            d="M116.27 123.88l-1.36 25.58-9.88.9-5.29-13.69-.83 14h-8.49l.68-26.75 9.44-.46 6.52 13.54.3-12.83zM135.58 135.38v2.21c0 .73 0 1.47-.11 2.21a16.39 16.39 0 01-1 4.46 12.38 12.38 0 01-2.2 3.69 10.16 10.16 0 01-3.37 2.51 10.71 10.71 0 01-4.55.92 12.67 12.67 0 01-2.08-.17 13.69 13.69 0 01-2.15-.51 12.15 12.15 0 01-2-.84 8.22 8.22 0 01-1.72-1.16l1.17-7.81a9.65 9.65 0 002.47 1.75 6.53 6.53 0 003 .67 4.5 4.5 0 001.75-.3 3.35 3.35 0 001.19-.83 4.19 4.19 0 00.75-1.24 7.11 7.11 0 00.39-1.51 12.49 12.49 0 00.15-1.65v-1.68a59.37 59.37 0 00-.3-6q-.3-3-.53-5.95l8.64-.57q.5 5.93.5 11.8zM160.25 149.31l-9.36 1.2-1.13-4.26h-4.3l-.94 4.26-9.62-.94 7.5-25.13 10.49-.53zm-11.17-8.83l-1.43-6.57-1.4 6.57z"
          ></path>
          <g style={{ isolation: "isolate" }} fill="#fff">
            <path d="M166.23 127.12a6.56 6.56 0 01-.38 2 10 10 0 01-1 2.13 12.41 12.41 0 01-1.63 2 9.07 9.07 0 01-2.14 1.55v-.44-1c0-.37 0-.84-.07-1.31s0-.88 0-1.24a3.72 3.72 0 01-1.85-1.46 4 4 0 01-.68-2.24 3.77 3.77 0 01.31-1.53 3.9 3.9 0 01.85-1.25 4.16 4.16 0 011.25-.86 3.89 3.89 0 013.09 0 4.09 4.09 0 011.26.86 3.93 3.93 0 01.86 1.25 3.61 3.61 0 01.3 1.53zM186.7 140.89a10.75 10.75 0 01-.89 4.52 9.08 9.08 0 01-2.46 3.22 10.39 10.39 0 01-3.64 1.92 15.07 15.07 0 01-4.48.64 9.62 9.62 0 01-2-.24c-.73-.16-1.48-.37-2.23-.61s-1.48-.51-2.18-.8-1.32-.55-1.86-.8l.83-7.77a13.13 13.13 0 003.56 1.46 15.58 15.58 0 003.84.5h.86a3.94 3.94 0 001-.17 2.1 2.1 0 00.78-.42 1 1 0 00.32-.81.91.91 0 00-.23-.62 1.68 1.68 0 00-.58-.41 3.67 3.67 0 00-.81-.25l-.89-.12h-1.42a7.6 7.6 0 01-2.95-.56 6.81 6.81 0 01-2.28-1.58 7 7 0 01-1.48-2.39 8.46 8.46 0 01-.53-3 8.62 8.62 0 01.9-4 9.1 9.1 0 012.39-3 10.72 10.72 0 013.45-1.9 12.35 12.35 0 014-.66c.62 0 1.26 0 1.91.07a18.5 18.5 0 011.95.23 19.45 19.45 0 011.9.44 10.18 10.18 0 011.75.66l-.71 7.66a24.63 24.63 0 00-2.69-.73A13.83 13.83 0 00179 131h-.63a7.65 7.65 0 00-.81 0c-.28 0-.57.08-.86.15a3.16 3.16 0 00-.77.25 1.58 1.58 0 00-.55.42 1 1 0 00.12 1.3 2 2 0 00.76.39 4.85 4.85 0 001 .2c.37 0 .73.06 1.1.07h1a4.43 4.43 0 01.77 0 7.55 7.55 0 012.72.64 6 6 0 013.33 3.61 8.41 8.41 0 01.52 2.86zM218.21 147.08A8.76 8.76 0 01216 149a13.94 13.94 0 01-2.79 1.38 17.29 17.29 0 01-3.06.82 17.6 17.6 0 01-3 .28 12.66 12.66 0 01-5-1 12 12 0 01-4-2.7 12.58 12.58 0 01-2.61-4.07 13.31 13.31 0 01-.94-5 16.89 16.89 0 01.47-4 16.48 16.48 0 011.35-3.72 15.35 15.35 0 012.14-3.21 14 14 0 012.86-2.52A13.56 13.56 0 01209 123c.54 0 1.12 0 1.73.06s1.23.12 1.84.23a15.09 15.09 0 011.79.44 9.1 9.1 0 011.58.7l-.53 7.21a9.53 9.53 0 00-2.18-.54 18.28 18.28 0 00-2.19-.14 8.44 8.44 0 00-2.83.46 6.81 6.81 0 00-2.28 1.33 6.33 6.33 0 00-1.54 2.12 6.81 6.81 0 00-.56 2.81 7 7 0 00.26 1.89 5.11 5.11 0 00.8 1.62 4.13 4.13 0 001.34 1.15 3.87 3.87 0 001.86.43 6 6 0 001.48-.19 3.15 3.15 0 001.31-.64l.08-1.47-4.53-.08.23-5.66 5.62-.16c1.87 0 3.76-.1 5.66-.18zM243.43 149.31l-9.36 1.2-1.13-4.26h-4.3l-.94 4.26-9.62-.94 7.5-25.13 10.49-.53zm-11.17-8.83l-1.43-6.57-1.4 6.57zM273 123.42l-1.73 27.7-8.61.38.08-14.61-3.89 11.78h-3.32l-3-10.53v12.22l-8.71.27.38-26.07 9.69-.38 3.85 12.49 5.13-13.25zM292.24 123.73c-.08 1.18-.15 2.35-.21 3.5s-.15 2.33-.25 3.51l-8 .42-.18 2.38h5.62l-.42 5.84-5.66.19-.19 2.76h8c-.07 1.38-.15 2.76-.23 4.12s-.16 2.73-.22 4.1l-16.26.38.6-27.2zM312.2 140.89a10.6 10.6 0 01-.9 4.52 9.05 9.05 0 01-2.45 3.22 10.48 10.48 0 01-3.64 1.92 15.12 15.12 0 01-4.48.64 9.55 9.55 0 01-2-.24c-.74-.16-1.48-.37-2.24-.61s-1.48-.51-2.18-.8-1.31-.55-1.86-.8l.83-7.77a13.26 13.26 0 003.56 1.46 15.58 15.58 0 003.84.5h.87a3.86 3.86 0 001-.17 2 2 0 00.78-.42 1 1 0 00.32-.81.91.91 0 00-.22-.62 1.73 1.73 0 00-.59-.41 3.67 3.67 0 00-.81-.25l-.89-.12H299.73a7.57 7.57 0 01-2.95-.56 6.85 6.85 0 01-2.29-1.58 7.36 7.36 0 01-1.48-2.39 8.46 8.46 0 01-.53-3 8.62 8.62 0 01.9-4 9.26 9.26 0 012.4-3 10.67 10.67 0 013.44-1.9 12.41 12.41 0 014-.66c.61 0 1.25 0 1.9.07a18.38 18.38 0 012 .23 19.25 19.25 0 011.89.44 10.29 10.29 0 011.76.66L310 132a23.46 23.46 0 00-2.69-.73 13.81 13.81 0 00-2.74-.29h-.63a8 8 0 00-.82 0 8.41 8.41 0 00-.85.15 3.4 3.4 0 00-.78.25 1.54 1.54 0 00-.54.42.88.88 0 00-.19.63.89.89 0 00.31.67 1.9 1.9 0 00.75.39 5.12 5.12 0 001 .2c.37 0 .74.06 1.1.07h1a4.55 4.55 0 01.78 0 7.49 7.49 0 012.71.64 6.24 6.24 0 012.05 1.45 6 6 0 011.28 2.16 8.15 8.15 0 01.46 2.88zM330.18 122.9l-1.55 19.84h-7l-.72-19.84zm-1.25 25.65a3.8 3.8 0 01-.32 1.55 4.11 4.11 0 01-2.11 2.1 3.77 3.77 0 01-1.53.31 3.89 3.89 0 01-2.8-1.16 3.9 3.9 0 01-.85-1.25 3.8 3.8 0 01-.31-1.55 3.85 3.85 0 01.31-1.54 3.92 3.92 0 01.85-1.28 4.22 4.22 0 011.25-.86 3.84 3.84 0 011.55-.32 3.78 3.78 0 011.53.32 4.35 4.35 0 011.25.86 4 4 0 01.86 1.28 3.86 3.86 0 01.32 1.54z"></path>
          </g>
        </g>
        <g style={{ isolation: "isolate" }} fill="#fff">
          <path d="M175.3 94.09l-5.8.83-.7-2.92h-2.66l-.58 2.93-6-.65L164.25 77l6.49-.36zM168.38 88l-.88-4.5-.87 4.5zM188.77 84.93a11.71 11.71 0 01-.42 3.26 9.17 9.17 0 01-1.17 2.59 8.18 8.18 0 01-1.8 2 10.13 10.13 0 01-2.27 1.34 12 12 0 01-2.64.77 15.85 15.85 0 01-2.86.26h-1.08l-1.07-.15.33-17.36a12.41 12.41 0 012.64-.64 19.06 19.06 0 012.7-.19 8.22 8.22 0 013.07.55 6.94 6.94 0 012.42 1.61 7.15 7.15 0 011.58 2.56 9.68 9.68 0 01.57 3.4zm-4.79.83a5.43 5.43 0 00-.13-1.35 3.44 3.44 0 00-.48-1.14 2.53 2.53 0 00-.85-.81 2.6 2.6 0 00-1.22-.33l-.47 8a2.89 2.89 0 001.27-.51 4 4 0 001-1 4.39 4.39 0 00.64-1.28 5.07 5.07 0 00.25-1.45zM207.52 76.34l-1.07 19-5.33.26v-10l-2.41 8.08h-2l-1.85-7.22v8.38l-5.39.18.23-17.88 6-.25 2.38 8.56 3.18-9.08zM214.68 77l-1.29 17.6-4.92.29V77.35zM231.36 76.65l-.84 17.54-6.12.62-3.27-9.39-.51 9.58h-5.25l.42-18.34 5.83-.31 4 9.31.19-8.79z"></path>
        </g>
      </g>
    </svg>
  );
}

export default HomeSplash;
